export const namespaced = true;

export const state = {
  formularioForm: undefined,
};

export const mutations = {
  SET_FORMULARIO_FORM(state, formulario) {
    state.formularioForm = formulario;
  },
};

export const actions = {
  guardarFormulario({commit}, formulario) {
    commit('SET_FORMULARIO_FORM', formulario);
  },
  limpiarFormulario({commit}){
    commit('SET_FORMULARIO_FORM', undefined);
  }
};

export const getters = {};
